var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "mt-5" },
    [
      _c("section-title", {
        attrs: {
          content: "Detalles de la propuesta",
          icon: "fas fa-info",
          reverse: ""
        }
      }),
      _vm._l(_vm.questionnaireQuestionSection, function(questionAnswers, key) {
        return _c(
          "section-title-collapse",
          { key: key, attrs: { title: key } },
          _vm._l(questionAnswers, function(item, key) {
            return _c("div", { key: key }, [
              item.questionAnswer.answer.text != null ||
              item.questionAnswer.answer.boolean != null
                ? _c("div", { staticClass: "row mb-3" }, [
                    _c("div", { staticClass: "col" }, [
                      _c(
                        "div",
                        {
                          staticClass: "color-gray-6 font-14 font-weight-normal"
                        },
                        [
                          _vm._v(
                            " " + _vm._s(item.questionAnswer.questionText) + " "
                          )
                        ]
                      ),
                      _c(
                        "div",
                        {
                          staticClass:
                            "color-black font-14 font-weight-normal pl-3 mt-1"
                        },
                        [
                          _vm._v(
                            " " +
                              _vm._s(item.questionAnswer.questionNumberLabel) +
                              " "
                          )
                        ]
                      ),
                      _c(
                        "div",
                        {
                          staticClass: "color-black font-16 font-weight-normal",
                          class: item.questionAnswer.questionNumberLabel
                            ? "pl-3"
                            : ""
                        },
                        [
                          item.questionAnswer.answer.text
                            ? [
                                _vm._v(
                                  " " +
                                    _vm._s(item.questionAnswer.answer.text) +
                                    " "
                                )
                              ]
                            : [
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      _vm._f("boolText")(
                                        item.questionAnswer.answer.boolean
                                      )
                                    ) +
                                    " "
                                )
                              ]
                        ],
                        2
                      ),
                      Object.values(_vm.questionProposalType).includes(
                        item.questionAnswer.id
                      ) && item.questionAnswer.answer.boolean
                        ? _c("div", [
                            _c(
                              "div",
                              {
                                staticClass:
                                  "color-gray-6 font-14 font-weight-normal mt-3"
                              },
                              [[_vm._v(" Nombre de la Corporación ")]],
                              2
                            ),
                            _c(
                              "div",
                              {
                                staticClass:
                                  "color-black font-16 font-weight-normal"
                              },
                              [
                                [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        item.questionAnswer.answer
                                          .previousCompanyName
                                      ) +
                                      " "
                                  )
                                ]
                              ],
                              2
                            )
                          ])
                        : _vm._e()
                    ])
                  ])
                : item.questionAnswer.questionAnswerModeId ==
                  _vm.answerModes.Documento
                ? _c(
                    "div",
                    { staticClass: "bg-secondary-3 mt-3 rounded py-3 px-4" },
                    [
                      _c("div", { staticClass: "row" }, [
                        _c("div", { staticClass: "col-md-6" }, [
                          _c("label", { staticClass: "data-title mb-0" }, [
                            _vm._v("Documento:")
                          ]),
                          _c("h6", [
                            _vm._v(
                              _vm._s(
                                _vm._f("empty")(
                                  item.questionAnswer.questionText
                                )
                              )
                            )
                          ])
                        ]),
                        _c("div", { staticClass: "col-md-4" }, [
                          _c("label", { staticClass: "data-title mb-0" }, [
                            _vm._v("Archivo:")
                          ]),
                          _c("h6", [
                            _vm._v(
                              _vm._s(
                                _vm._f("empty")(
                                  item.questionAnswer.answer.file.filename
                                )
                              )
                            )
                          ])
                        ]),
                        _c(
                          "div",
                          {
                            staticClass:
                              "col-md-2 d-flex align-items-center justify-content-end"
                          },
                          [
                            item.questionAnswer.answer.file.documentId
                              ? _c(
                                  "div",
                                  { staticClass: "mt-3" },
                                  [
                                    _c("action-button", {
                                      staticClass: "mr-2 bg-green border-green",
                                      attrs: {
                                        id:
                                          "download-document" +
                                          item.questionAnswer.answer.file
                                            .documentId,
                                        i:
                                          "fas fa-file-download text-white mr-n1 pr-1"
                                      },
                                      on: {
                                        click: function($event) {
                                          return _vm.downloadDocument(
                                            item.questionAnswer.answer.file
                                          )
                                        }
                                      }
                                    }),
                                    _c("action-button", {
                                      staticClass:
                                        "border-green bg-transparent",
                                      attrs: {
                                        id:
                                          "view-document" +
                                          item.questionAnswer.answer.file
                                            .documentId,
                                        i:
                                          "fas fa-search-plus text-green mr-n1 pr-1"
                                      },
                                      on: {
                                        click: function($event) {
                                          return _vm.viewDocument(
                                            item.questionAnswer.answer.file
                                          )
                                        }
                                      }
                                    })
                                  ],
                                  1
                                )
                              : _vm._e()
                          ]
                        )
                      ])
                    ]
                  )
                : _vm._e()
            ])
          }),
          0
        )
      })
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }